import { Box, Heading } from '@chakra-ui/react';
import { FC, useContext } from 'react';
import EntityContext from '../../../context/EntityContext';
import { ParagraphActivityPoiProductsInRegionFragment } from '../../../generated/types';
import { ProductListGridSlider } from '../../Common/ProductListGridSlider';

interface ActivityPoiProductsInRegionProps {
  data: ParagraphActivityPoiProductsInRegionFragment;
}

export const ActivityPoiProductsInRegion: FC<ActivityPoiProductsInRegionProps> = ({
  data,
}) => {
  const entityContext = useContext(EntityContext);

  if (!('productsInRegion' in entityContext.entity)) {
    return null;
  }

  return (
    <Box overflow="hidden" maxW="100%">
      <ProductListGridSlider
        title={data.title}
        items={entityContext.entity.productsInRegion.items}
      />
    </Box>
  );
};

export default ActivityPoiProductsInRegion;
